import router from 'src/router'
import i18n from 'src/plugins/i18n'
import Repositories from 'src/repositories'
import AxiosAuthenticationToken from 'src/services/axios/authentication/token'
import AxiosAuthenticationEvent from 'src/services/axios/authentication/event'

export async function init ({ commit, getters }) {
  // Update token if changed
  AxiosAuthenticationEvent.on('tokenRefreshSuccessful', tokens => {
    commit('SET_TOKENS', tokens)
  })

  // Logout if token is invalid
  AxiosAuthenticationEvent.on('tokenRefreshFailed', () => {
    commit('LOGOUT')
    router.push('/login')
  })

  if (getters.isAuthenticated) {
    // Add user token to axios requests
    AxiosAuthenticationToken.set(getters.tokens)

    // Refresh user data on app init
    const { company, ...user } = await Repositories.me.get()
    commit('SET_USER', user)
    commit('SET_COMPANY', company)
  }
}

export async function login ({ dispatch, commit, getters }, credentials) {
  try {
    const response = await Repositories.me.login(credentials)

    const {
      accessToken,
      refreshToken,
      company,
      ...user
    } = response.data

    AxiosAuthenticationToken.set({ accessToken, refreshToken })

    commit('LOGIN', {
      user,
      company,
      accessToken,
      refreshToken,
    })

    const notification = i18n.t('general.welcome', { name: getters.fullname })
    dispatch('ui/showSuccessNotification', notification, { root: true })

    router.push('/')
  }
  catch (error) {
    const notification = Repositories.parseErrorMessage(error)
    dispatch('ui/showErrorNotification', notification, { root: true })
    throw error
  }
}

export async function logout ({ dispatch, commit }) {
  try {
    await Repositories.me.logout()
  }
  catch (error) {
    const notification = Repositories.parseErrorMessage(error)
    dispatch('ui/showErrorNotification', notification, { root: true })
  }
  finally {
    // Ensure client logout, even if a server error has occured
    commit('LOGOUT')
    router.push('/login')
  }
}

export async function updateMe ({ dispatch, commit, getters }, partialUserData) {
  try {
    await Repositories.me.updateMe(partialUserData)
    // Don't keep the password in the store
    const { password, ...userData } = partialUserData
    commit('SET_USER', { ...getters.user, ...userData })

    const notification = i18n.t('user.accountUpdated')
    dispatch('ui/showSuccessNotification', notification, { root: true })

    return { error: null }
  }
  catch (error) {
    const notification = Repositories.parseErrorMessage(error)
    dispatch('ui/showErrorNotification', notification, { root: true })

    // Utilisateur déjà existant
    return Repositories.getErrorCode(error)
  }
}

export async function updateMyCompany ({ dispatch, commit }, partialCompanyData) {
  try {
    const company = await Repositories.myCompany.patch(partialCompanyData)
    commit('SET_COMPANY', company)

    const notification = i18n.t('company.myCompanyUpdated')
    dispatch('ui/showSuccessNotification', notification, { root: true })
  }
  catch (error) {
    const notification = Repositories.parseErrorMessage(error)
    dispatch('ui/showErrorNotification', notification, { root: true })
  }
}

export async function refreshUser ({ dispatch, commit, getters }) {
  if (getters.userId) {
    try {
      const { companyId, ...user } = await Repositories.user.get(getters.userId)
      commit('SET_USER', user)
    }
    catch (error) {
      const notification = Repositories.parseErrorMessage(error)
      dispatch('ui/showErrorNotification', notification, { root: true })
      throw error
    }
  }
}

export async function refreshCompany ({ dispatch, commit, getters }) {
  if (getters.isAuthenticated) {
    try {
      const company = await Repositories.myCompany.get()
      commit('SET_COMPANY', company)
    }
    catch (error) {
      const notification = Repositories.parseErrorMessage(error)
      dispatch('ui/showErrorNotification', notification, { root: true })
      throw error
    }
  }
}
